import React, { useCallback, useEffect, useState, useRef } from 'react';
// import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import Table from 'react-bootstrap/Table';

import ProfileAvatar from "../../../../../../ui/ProfileAvatar";
import Pagination from "../../../../../../ui/Pagination";
import NoDataFound from "../../../../../../ui/NoDataFound";
import SkeletonLoader from "../../../../../../ui/SkeletonLoader";
import RadioButton from "../../../../../../ui/RadioButton";
import Button from "../../../../../../ui/Button";

import { filterIcon, searchIcon } from "../../../../../../../utils/icons";
import { getCountryImageUrl } from "../../../../../../../utils/util";

import { useSelector, useDispatch } from 'react-redux';
import { getMXRecord, resetDnsRecordList } from "../../../../../../../store/actions/scanInfoAction";

import apiEndpoints from "../../../../../../../apiEndpoints";

const newFindingsOption = [    
    {
        label: "Yes",
        value: "yes"
    },
    {
        label: "No",
        value: "no"
    },
    {
        label: "All",
        value: "all"
    }
]

const MXRecord = ({selectedSubdomain, domainId, scanId, organizationId, currentPageType="subdomain"}) => {

    const mxRecord = useSelector((state) => state?.scanInfo.mxRecord);

    const prevDomainIdRef = useRef(null);
    const prevScanIdRef = useRef(null);
    const filterWrapperRef = useRef(null);

    const dispatch = useDispatch();

    const [searchValue, setSearchValue] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isSearchFocused, setIsSearchFocused] = useState(false);

    const [mxRecordList, setMxRecordList] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [scanNotFound, setScanNotFound] = useState(false);

    //filter value
    const [showFilter, setShowFilter] = useState(false);
    const [newFindingsType, setNewFindingsType] = useState("");

    //selected filter value
    const [selectedFilterValue, setSelectedFilterValue] = useState({});

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isSearchFocused) {
            onSearch()
        }
    }

    const onSearch = () => {
        setCurrentPage(1)
        setSearchQuery(searchValue)
    }

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const applyFilter = () => {
        setCurrentPage(1);
        let obj = {
            findings: newFindingsType,
        }
        setSelectedFilterValue(obj)
        setShowFilter(false);
    }

    const isAnyFilterActive = Object.values(selectedFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {        
        setCurrentPage(1);
        setSelectedFilterValue({})
        setNewFindingsType("");
    }

    const fetchRecordData = useCallback(()=> {
        const currentDomain = prevDomainIdRef.current;
        const queryParams = searchQuery ? `&query=${searchQuery}` : "";
        const newFindings = selectedFilterValue.findings && selectedFilterValue.findings !== "all" ? `&new_record=${selectedFilterValue.findings === "yes" ? true : false}` : "";
        if(currentPageType === "subDomain") {
            setIsLoading(true)
            const baseUrl = `${apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.subDomain.mxRecord()}&page=${currentPage}&page_size=${currentPageSize}&subdomain=${selectedSubdomain?.subdomain}&domain=${selectedSubdomain?.domain}&scan_id=${selectedSubdomain?.scan_id}`
            const url = `${baseUrl}${queryParams}${newFindings}`
            dispatch(getMXRecord(url))
        } else if(currentPageType === "similarDomain") {
            setIsLoading(true)
            const baseUrl = `${apiEndpoints.scanInfo.exposureManagemnet.brandInsight.similarDomain.mxRecord()}&page=${currentPage}&page_size=${currentPageSize}&similar_domain=${selectedSubdomain?.similar_domain}&domain=${selectedSubdomain?.domain}&scan_id=${selectedSubdomain?.scan_id}`;
            const url = `${baseUrl}${queryParams}${newFindings}`
            dispatch(getMXRecord(url))
        } else {
            setIsLoading(true)
            const baseUrl = `${apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.dnsRecord.mxRecord()}&page=${currentPage}&page_size=${currentPageSize}`
            const params = organizationId.toLowerCase() !== "all" && currentDomain.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${currentDomain}&scan_id=${scanId}`;
            const url = `${baseUrl}${params}${queryParams}${newFindings}`
            dispatch(getMXRecord(url))
        }

    },[currentPageType, dispatch, selectedSubdomain, currentPage, currentPageSize, scanId, organizationId, searchQuery, selectedFilterValue])

    useEffect(()=>{
        if(selectedSubdomain || domainId !== prevDomainIdRef.current || scanId !== prevScanIdRef.current) {
            setCurrentPage(1);
            prevDomainIdRef.current = domainId;
            prevScanIdRef.current = scanId;
        }
    },[domainId, scanId, selectedSubdomain]);

    useEffect(()=>{
        fetchRecordData()
    },[currentPageSize, currentPage, fetchRecordData])

    useEffect(()=>{
        if(mxRecord !== null) {
            if(mxRecord?.status === "failed") {
                setScanNotFound(true)
                setMxRecordList(mxRecord)
                dispatch(resetDnsRecordList())
            } else {
                setScanNotFound(false)
                setMxRecordList(mxRecord)
                dispatch(resetDnsRecordList())
            }
            setIsLoading(false)            
        }
    },[mxRecord, dispatch])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                }
            }
        }
    },[showFilter])

    return (
        <div className="record-container-content p-2">
            <div className="search-header-container d-flex align-items-center gap-3">
                <div className="d-flex gap-3" onKeyDown={handleSearchKeyDown}>
                    <div className="search-container position-relative">
                        <span className="position-absolute">{searchIcon()}</span>
                        <input type="text" 
                            placeholder="Search" 
                            value={searchValue} 
                            onChange={(e)=>{
                                setSearchValue(e.target.value)
                            }}
                            onFocus={() => setIsSearchFocused(true)}
                            onBlur={() => setIsSearchFocused(false)}
                        />
                    </div>
                    <button className="search-btn" onClick={onSearch}>Search</button>
                </div>
                <div className="position-relative">
                    <span className="filter-icon" onClick={()=>{setShowFilter(true)}}>{filterIcon()}</span>                        
                    {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                    {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                        <h6>New Findings</h6>
                        <div className="filter-user-status d-flex mb-4 gap-4">
                            {
                                newFindingsOption.map((data,index)=>{
                                    return (
                                        <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setNewFindingsType(value)}} key={index} isChecked={data.value === newFindingsType} />
                                    )
                                })
                            }
                        </div>
                        <div className="filter-apply-btn mt-3">
                            <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={newFindingsType === ""} buttonClicked={()=>{applyFilter()}}/>
                        </div>
                    </div>}
                </div>
            </div>
            <div className="table-container mt-3 record-table">
                {
                    isLoading ?
                    <SkeletonLoader type={"line"} count={5} currentPage={"mxRecord"} />
                    :
                    <Table responsive="lg">
                        <thead>
                            <tr>
                                <th>{currentPageType === "similarDomain" ? "Similar Domain" : "Subdomain"}</th>
                                <th>Record</th>
                                <th>Organization</th>
                                <th>AS Details</th>
                                <th>Country Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                mxRecordList !== "" && mxRecordList?.results?.length > 0 && 
                                mxRecordList?.results.map((data, index) => {
                                    return (
                                        <motion.tr
                                            key={index}
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4, delay: index * 0.1 }}
                                        >
                                            <td>
                                                {<p className="dns-record-subdomain">{currentPageType === "similarDomain" ? data?.similar_domain : data?.subdomain }</p>}
                                                <span className="dns-record-domain">{data?.domain}</span>
                                                {data?.new_record && <p><span className="d-inline-block new-data mr-2">New</span></p>}
                                            </td>
                                            <td>
                                                {data?.record}
                                            </td>
                                            <td>
                                                <p>{data?.organization}</p>
                                            </td>
                                            <td>
                                                <p>{data?.as_number}</p>
                                            </td>
                                            <td>
                                                <ProfileAvatar type={"profile"} firstName={data?.city} lastName={""} secondaryText={`${data.country}, ${data.continent}`} imageUrl={getCountryImageUrl(data)}/>
                                            </td>
                                        </motion.tr>
                                    )
                                })
                            }
                            {   scanNotFound &&
                                <motion.tr
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <td colSpan={5}>
                                        <NoDataFound noDataText={mxRecordList?.description}/>
                                    </td>                                    
                                </motion.tr>
                            }
                            {
                                !scanNotFound && mxRecordList !== "" && mxRecordList?.results?.length === 0 && 
                                <motion.tr
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <td colSpan={5}>
                                        <NoDataFound noDataText={"No Record Found"} />
                                    </td>                                    
                                </motion.tr>
                            }
                        </tbody>
                    </Table>
                }
                
            </div>
            {mxRecordList !== "" && mxRecordList?.results?.length > 0 && <Pagination
                className="pagination-bar"
                currentPage={currentPage}
                pageSize={currentPageSize}
                totalCount={mxRecordList?.meta?.total_results}
                onPageChange={setCurrentPageandRecordSize}
            />}
        </div>
    )
}

export default MXRecord;